
<div>
  <!--Side-bar-->
  <app-side-bar *ngIf="showSideBar" [sections]="this.sections"></app-side-bar>

  <!--Top menu -->
  <ng-container *ngIf="this.company">
    <app-top-menu style="display: block;" [ngStyle]="{ height: getHeight() }"></app-top-menu>
  </ng-container>
  

  <!--Div que é mostrada no modo tablet/celular para quando a pessoa descer to topo da pagina-->
  <app-top-header (showInput)="this.showInput = $event"></app-top-header>

  <!--Categorias no menu superior-->
  <app-top-bar [sections]="this.sections" [tabela]="this.tabela" [verifiScrolling]="this.verifiScrolling"></app-top-bar>

  <!--Menu inteiro-->
  <div #menu>
    <div class="page-wrapper" [ngClass]="{'isMobile': this.isMobile, 'isTablet': this.isTablet, 'isDesktop': this.isDesktop, 'local': this.local, 'readOnly': this.readOnlyState}">
      <div class="menu">
        <!--Lista de Categorias, para listar os produtos-->
        <div class="lista-category">
          <!--Primeira Lista-->
          <ng-container *ngFor="let category of tabela; let last = last; let indexSection = index" >
            <ng-container *ngIf="(category.products | filtro: filter : 'name').length > 0">
              <section class="painel" [id]="category.categoryName" [ngStyle]="{'margin-bottom.px': last ? 0 : 40}" #sections>
                <div class="title-painel">
                  <h2 style="margin-bottom: 0px;">{{ category.categoryName }}</h2>
                </div>
                <div class="body-painel">
                  <div class="products">
                    <ng-container *ngFor="let product of category.products | filtro: this.filter: 'name'; let index = index">
                      <ng-container>
                        <div class="product-card">
                          <a (click)="capturaId(product.id_product, indexSection)">
                            <div class="body-card">
                              <div class="d-flex">
                                <div class="image-card" [ngClass]="{'not-animation': this.imgsLoadead[index]}">
                                  <img [src]="product.image_prod" (load)="this.loadImgComplete($event, index)" style="width: 100px; height: 100px;">
                                </div>

                              </div>
                              <div class="info-card">
                                <div class="description-card">
                                  <div class="name-card" [textContent]="product.name"></div>
                                  <div class="detail-card" [textContent]="product.description"></div>
                                </div>
                                <ng-container *ngIf="product.price != 0">
                                  <ng-container *ngIf="product.promotion == 1">
                                    <div class="box-card-promotion">
                                      <span style="width: 100%;" class="value-card__Promotion">
                                        {{ product.realPrice | currency:'BRL' }}
                                      </span>
                                      <span>
                                        {{ product.price | currency:'BRL' }}
                                      </span>
                                    </div>
                                  </ng-container>
                                  <ng-container *ngIf="product.promotion == 0">
                                    <span style="width: 100%;" class="value-card__value">
                                      {{ product.price | currency:'BRL' }}
                                    </span>
                                  </ng-container>
                                </ng-container>
                                <ng-container *ngIf="product.price == 0">
                                  <ng-container *ngIf="product.pizza == 1">
                                    <ng-container *ngIf="product.minPrice != '0' ">
                                      <div style="display: flex; width: 100%; justify-content: flex-end; gap: 10px; align-items: center;">
                                        <span class="span_card__value">A partir de</span>
                                        <span class="value-card__value">
                                          {{ product.minPrice | currency:'BRL' }}
                                        </span>
                                      </div>
                                    </ng-container>
                                  </ng-container>
                                </ng-container>
                              </div>
                              <ng-container *ngIf="product.price == 0">
                                <ng-container *ngIf="product.pizza == 0">
                                  <i class="fa fa-chevron-right" style="color: #652969;"></i>
                                </ng-container>
                              </ng-container>
                            </div>
                          </a>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </section>
            </ng-container>

          </ng-container>

          <!--Se nenhum produto for encontrado-->
          <ng-container *ngIf="emptyProduct">
            <div class="message-not-found">
              <span style="color: gray">Nenhum Produto encontrado</span>
            </div>
          </ng-container>

          <!--Logo Final da lista-->
          <div class="WariningPowered">
            <div style="position: relative; top: 17px; left: 2px;">
              <span style=" color: #652969; font-size: 13px;">from</span>
            </div>
            <div>
              <img src="assets/logo/logo-qrcode-pedeaqui.png" style="width: 32px;"/><img src="assets/logo/logo-name-pedeaqui.png" style="width: 100px;"/>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
